import { useEffect, useState } from "react";
import { Container } from "@mui/material";
import { UserRepository } from "@amityco/ts-sdk";
import { Collector } from "../../services/shirts/types";
import MenuService from "../../components/Menu/menuService";
import BackdropLoaderService from "../../components/BackdropLoader/backdropLoaderService";
import UserService from "../../services/userService";
import Filter from "./Filter";
import CollectorsResult from "./CollectorsResult";
import { GridPaginationModel } from "@mui/x-data-grid";

const SearchForCollectors = () => {
  const [collectors, setCollectors] = useState<Array<Collector>>([]);
  const { open: openBDL, close: closeBDL } = BackdropLoaderService();
  const { selectPage } = MenuService();
  const { searchUsers } = UserService();

  const [totalPageCount, setTotalPageCount] = useState<number>();
  const [searchText, setSearchText] = useState<string | undefined>();
  const [paginationModel, setPaginationModel] = useState<GridPaginationModel>({
    page: 1,
    pageSize: 10,
  });

  const search = async () => {
    openBDL();
    const results = await searchUsers(
      searchText,
      paginationModel.page,
      paginationModel.pageSize
    );

    const usersArray = Array.isArray(results)
      ? results
      : results && Array.isArray(results.collectors)
        ? results.collectors
        : [];

    const collectors = [];

    for (const user of usersArray) {
      try {
        // const followInfo = await getFollowingInfo(user.id);
        const collector = {
          id: user.id,
          item_count: user.item_count,
          user_name: user.user_name,
          profile_image: user.profile_image,
          biggest_club_collection_name: user.biggest_club_collection_name,
          biggest_club_collection_count: user.biggest_club_collection_count,
          match_worn_item_count: user.match_worn_item_count,
          collection_value: user.collection_value,
          // followers: followInfo.followerCount,
          // following: followInfo.followingCount,
          is_vip: user.is_vip,
          country: user.country,
        };
        collectors.push(collector);
      } catch (error) {
        console.error("Error fetching followInfo for user", user.id, error);
      }
    }

    if (results && "meta" in results && results.meta) {
      setTotalPageCount(results.meta.last_page);
    } else {
      setTotalPageCount(undefined);
    }
    setCollectors(collectors);
    closeBDL();
  };

  const getFollowingInfo = (
    userId: number
  ): Promise<{ followerCount: number; followingCount: number }> => {
    return new Promise((resolve, reject) => {
      try {
        UserRepository.Relationship.getFollowInfo(
          String(userId),
          ({ data: followInfo, loading, error }) => {
            if (loading) {
              // handle loading state
            }

            if (error) {
              // handle error
              resolve({ followerCount: 0, followingCount: 0 });
            }

            if (!loading && followInfo) {
              resolve({
                followerCount: followInfo.followerCount,
                followingCount: followInfo.followingCount,
              });
            }
          }
        );
      } catch (err) {
        console.error("Amity SDK client error:", err);
        resolve({ followerCount: 0, followingCount: 0 });
      }
    });
  };

  useEffect(() => {
    search();
  }, [paginationModel]);

  useEffect(() => {
    selectPage("search-for-collectors");
  }, []);

  return (
    <Container
      maxWidth={false}
      sx={{ padding: "0rem !important", backgroundColor: "#f4f6f8" }}
    >
      <Container maxWidth={"lg"} sx={{ paddingY: { xs: "2rem", sm: "3rem" } }}>
        <Filter setSearchText={setSearchText} handleBtnClick={search} />
        <CollectorsResult
          rows={collectors}
          totalPageCount={totalPageCount}
          paginationModel={paginationModel}
          syncPaginationModel={setPaginationModel}
        />
      </Container>
    </Container>
  );
};

export default SearchForCollectors;
